<div class="purchase-callback-banner">
  <mat-spinner [diameter]="50" class="spinner" color="success"></mat-spinner>
  <h2 class="title">SUCCESS!</h2>
  <h5 class="subtitle">You were redirected from Chargify</h5>
  <p class="description">And now we are just checking the status of your license. This may take several minutes...</p>
</div>